<template>
  <div class="card">
    <div class="card-header py-2">
      <!--<b-form-checkbox class="display-inline" v-model="checkedAll" :indeterminate="indeterminate">
      </b-form-checkbox>-->
      {{ $t('areas') }}
      <div style="float: right;">
        <button v-if="window.isDesktop" class="btn btn-primary btn-sm" @click="newArea">{{ $t('newArea') }}</button>&nbsp;
        <img @click="togglePanel" style="height: 13px; cursor: pointer;" :src="iconsVisible ? icons.chevronUp : icons.chevronDown" />
      </div>
    </div>
    <div v-show="iconsVisible" ref="areas" class="card-body p-2">
      <div v-for="area of $store.state.areas" :key="area.unique">
        <AppArea :area="area"></AppArea>
      </div>
    </div>
  </div>    
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import $ from 'jquery';
import Area from '@/ts/Area';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const iconsVisible: boolean = true;
        const checkedAll: Boolean = false;

        return {
            checkedAll,
            iconsVisible
        };
    },
    methods: {
        togglePanel() {
            //$(this.$refs.areas).slideToggle('slow');
            this.iconsVisible = !this.iconsVisible;
        },
        newArea() {
            const newArea: Area = new Area(Date.now(), 'Nowy obszar', '', '[]', '#FF0000', false);
            this.$store.state.areas.push(newArea);
            this.$store.commit('setEditedArea', newArea);
        }
    }
})


</script>